import FilterForm from 'components/forms/FilterForm';
import { DatePicker, Form, FormProps, Input, Select } from 'antd';
import { IClassroom } from 'interfaces/classrooms';
import { IGraduateCourse } from 'interfaces/graduate_courses';
import { useSelect } from '@refinedev/antd';

export interface ReadyForCertificatesFilterProps {
  searchFormProps: FormProps<IReadyForCertificateFilters>;
}

export interface IReadyForCertificateFilters {
  search_user_name: string;
  by_cpf: string;
  by_user_email: string;
  by_certification_status: string;
  by_course_code: string;
  by_classroom_id: string[];
  completed_after: string;
  completed_before: string;
  certificate_updated_after: string;
  certificate_updated_before: string;
}

export const ReadyForCertificatesFilter = ({
  searchFormProps
}: ReadyForCertificatesFilterProps) => {
  const { selectProps: courseSelectProps } = useSelect<IGraduateCourse>({
    resource: 'graduate_courses',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });

  const { selectProps: classroomSelectProps } = useSelect<IClassroom>({
    resource: 'classrooms',
    optionLabel: 'code',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[search_code]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });

  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="search_user_name">
        <Input placeholder="Nome do aluno" />
      </Form.Item>

      <Form.Item name="by_cpf">
        <Input placeholder="CPF" />
      </Form.Item>

      <Form.Item name="by_user_email">
        <Input placeholder="E-mail" />
      </Form.Item>

      <Form.Item name="by_course_code">
        <Input placeholder="Código do curso" />
      </Form.Item>

      <Form.Item name="by_classroom_id">
        <Select mode="multiple" {...classroomSelectProps} placeholder="Turma" />
      </Form.Item>

      <Form.Item name="completed_after">
        <DatePicker
          className="w-full"
          placeholder="Concluído (a partir de)"
          format="DD/MM/YYYY"
          picker="date"
        />
      </Form.Item>

      <Form.Item name="completed_before">
        <DatePicker
          className="w-full"
          placeholder="Concluído (até)"
          format="DD/MM/YYYY"
          picker="date"
        />
      </Form.Item>

      <Form.Item name="certificate_updated_after">
        <DatePicker
          className="w-full"
          placeholder="Atualização (a partir de)"
          format="DD/MM/YYYY"
          picker="date"
        />
      </Form.Item>

      <Form.Item name="certificate_updated_before">
        <DatePicker
          className="w-full"
          placeholder="Atualização (até)"
          format="DD/MM/YYYY"
          picker="date"
        />
      </Form.Item>

      <Form.Item name="by_certification_status" initialValue="">
        <Select placeholder="Status">
          <Select.Option key="">Todos</Select.Option>
          <Select.Option key="pending">Pendente</Select.Option>
          <Select.Option key="ready_for_issuance">
            Apto para emissão
          </Select.Option>
          <Select.Option key="pending_regulatory_review">
            Aguardando reguladora
          </Select.Option>
          <Select.Option key="approved">Aprovado para emissão</Select.Option>
          <Select.Option key="rejected">Rejeitado</Select.Option>
        </Select>
      </Form.Item>
    </FilterForm>
  );
};
